import { createAction, props } from '@ngrx/store';

import { ClientApiActions } from './action.model';
import {
  Client,
  ClientContactCreate,
  ClientCreate,
} from '@lockton-apps/shared/interfaces';

export const loadClientSuccess = createAction(
  ClientApiActions.LoadClientSuccess,
  props<{ client: Client }>()
);

export const loadClientFailure = createAction(
  ClientApiActions.LoadClientFailure,
  props<{ error: any }>()
);

export const loadClientsSuccess = createAction(
  ClientApiActions.LoadClientsSuccess,
  props<{ clients: Client[] }>()
);

export const loadClientsFailure = createAction(
  ClientApiActions.LoadClientsFailure,
  props<{ error: any }>()
);

export const loadClientAndSubClientsSuccess = createAction(
  ClientApiActions.LoadClientAndSubClientsSuccess,
  props<{ clients: Client[] }>()
);

export const loadClientAndSubClientFailure = createAction(
  ClientApiActions.LoadClientAndSubClientsFailure,
  props<{ error: any }>()
);

export const loadClientSuccessWithRelationshipChecks = createAction(
  ClientApiActions.LoadClientSuccessWithRelationshipChecks,
  props<{ client: Client }>()
);

export const loadPrimaryClientSuccess = createAction(
  ClientApiActions.LoadPrimaryClientSuccess,
  props<{ client: Client }>()
);

export const loadPrimaryClientFailure = createAction(
  ClientApiActions.LoadPrimaryClientFailure,
  props<{ error: any }>()
);

export const loadClientSubClientSuccess = createAction(
  ClientApiActions.LoadClientSubClientSuccess,
  props<{ clients: Client[] }>()
);

export const loadClientSubClientFailure = createAction(
  ClientApiActions.LoadClientSubClientFailure,
  props<{ error: any }>()
);

export const primaryClientAddedSuccess = createAction(
  ClientApiActions.PrimaryClientAddedSuccess,
  props<{
    client: Client;
    contact: ClientContactCreate;
    subClients: ClientCreate[];
  }>()
);

export const secondaryClientAddedSuccess = createAction(
  ClientApiActions.SecondaryClientAddedSuccess,
  props<{
    client: Client;
    addedClient: Client;
    subClients: ClientCreate[];
  }>()
);

export const secondaryClientsAddedComplete = createAction(
  ClientApiActions.SecondaryClientsAddedComplete
);

export const clientDataAddedComplete = createAction(
  ClientApiActions.ClientDataAddedComplete,
  props<{ client: Client }>()
);

export const primaryClientAddedFailure = createAction(
  ClientApiActions.PrimaryClientAddedFailure,
  props<{ error: unknown }>()
);

export const clientAddedSuccess = createAction(
  ClientApiActions.ClientAddedSuccess,
  props<{ client: Client }>()
);

export const clientAddedFailure = createAction(
  ClientApiActions.ClientAddedFailure,
  props<{ error: unknown }>()
);

export const clientUpdatedSuccess = createAction(
  ClientApiActions.ClientUpdatedSuccess,
  props<{ client: Client }>()
);

export const clientUpdatedFailure = createAction(
  ClientApiActions.ClientUpdatedFailure,
  props<{ error: unknown }>()
);
